import React from "react";

const ActionButton = ({
  label = "Add Tasks",
  icon = "/icons/add.png",
  className = "",
  onClick,
  hideIcon = false, // new prop
}) => {
  return (
    <div
      className={`w-24 h-6 rounded-[7px] bg-black flex items-center justify-center gap-2 cursor-pointer ${className}`}
      onClick={onClick}
    >
      {!hideIcon && (
        <img
          src={icon}
          alt="action-icon"
          className="w-[16px] h-[16px] object-contain"
        />
      )}
      <span className="font-inter text-[11px] leading-[100%] tracking-[0%] text-white">
        {label}
      </span>
    </div>
  );
};

export default ActionButton;
